module.exports = __webpack_public_path__ + "img/imgcomentarios.a1425ead.png";